import { Sheets } from "common/sheets";
export class Background {
    constructor(pixiContext, sheets) {
        this.sprite = Sheets.animation(pixiContext, sheets, "background");
        this.sprite.play();
        this.sprite.animationSpeed = 0.1;
    }
}
//# sourceMappingURL=background.js.map